import React from "react";
import SEO from "../components/SEO";
import { PAGES } from "../seo/pages.config";
import Breadcrumb from "../components/Breadcrumb";
import DevBuildArea from "../components/DevBuildArea";
import FooterFour from "../components/FooterFour";
import NavBarThree from "../components/NavbarThree";

const DevBuild = () => {
  return (
    <>
      <SEO canonical="/accelerator/dev-build" {...PAGES["/accelerator/dev-build"]} />
      {/* Navigation Bar */}
      <NavBarThree />

      {/* Navigation Bar */}
      <Breadcrumb title={"Evolvelab Dev Build"} />

      {/* Service Details Area */}
      <DevBuildArea />

      {/* Footer One */}
      <FooterFour />
    </>
  );
};

export default DevBuild;
